// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Barchart_wrapper__MlTbF {
  width: 100%;
  height: 100%;
  background: #ffffff;
  border-radius: 12px;
  padding: 3px;
  display: flex;
  flex-direction: column;
}

.Barchart_header__13lZr {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 6px;
}

.Barchart_title__cupRw {
  font-weight: 600;
  font-size: 14px;
  margin: 0 0 0 60px;
}

.Barchart_selector__MYx\\+H {
  display: flex;
  gap: 6px;
}

.Barchart_button__hExHu {
  padding: 4px 10px;
  font-size: 12px;
  border-radius: 20px;
  border: none;
  cursor: pointer;
  background: #eef2f7;
  color: #555;
  transition: all 0.2s ease;
}

.Barchart_active__Agfyy {
  background: #4e79a7;
  color: #ffffff;
}

.Barchart_svgWrapper__wE3Th {
  flex: 1 1;               /* 🔑 THIS aligns baselines */
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/componets/Dashboard_Summary/Components/Barchart.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAO,gBAAgB,6BAA6B;EACpD,WAAW;AACb","sourcesContent":[".wrapper {\n  width: 100%;\n  height: 100%;\n  background: #ffffff;\n  border-radius: 12px;\n  padding: 3px;\n  display: flex;\n  flex-direction: column;\n}\n\n.header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 6px;\n}\n\n.title {\n  font-weight: 600;\n  font-size: 14px;\n  margin: 0 0 0 60px;\n}\n\n.selector {\n  display: flex;\n  gap: 6px;\n}\n\n.button {\n  padding: 4px 10px;\n  font-size: 12px;\n  border-radius: 20px;\n  border: none;\n  cursor: pointer;\n  background: #eef2f7;\n  color: #555;\n  transition: all 0.2s ease;\n}\n\n.active {\n  background: #4e79a7;\n  color: #ffffff;\n}\n\n.svgWrapper {\n  flex: 1;               /* 🔑 THIS aligns baselines */\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `Barchart_wrapper__MlTbF`,
	"header": `Barchart_header__13lZr`,
	"title": `Barchart_title__cupRw`,
	"selector": `Barchart_selector__MYx+H`,
	"button": `Barchart_button__hExHu`,
	"active": `Barchart_active__Agfyy`,
	"svgWrapper": `Barchart_svgWrapper__wE3Th`
};
export default ___CSS_LOADER_EXPORT___;
